import { render, staticRenderFns } from "./InstructorCoursesList.vue?vue&type=template&id=d1860c70"
import script from "./InstructorCoursesList.vue?vue&type=script&lang=ts"
export * from "./InstructorCoursesList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports